module.exports = __webpack_public_path__ + "img/logo_eo.85ff84dd.png";